<template>
    <div
        class="o-dropdown-items-type"
    >
        <span 
            v-if="label"
            class="o-dropdown-items-type__label"
        >
            {{ label }}
        </span>
        <div
            class="o-dropdown-items-type__select"
        >
            <div
                class="o-dropdown-items-type__title"
            >
                {{$t('ui.o-dropdown-items-type-title')}}
            </div>
            <div
                class="o-dropdown-items-type__types"
            >
                <div
                    :class="[
                        'o-dropdown-items-type__type',
                        item.type === value ? 'active' : ''
                    ]"
                    v-for="item in dropdownItemsTypes"
                    :key="item.name"
                    v-show="!value || item.type === value"
                    @click="changeDropdownType(item.type)"
                >
                    {{item.name}}

                    <svg-icon
                        v-show="value"
                        class="o-dropdown-items-type__type-icon"
                        original
                        :name="`icons/close`"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ODropdownItemsType',
    props: {
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dropdownItemsTypesDefault: [
                {
                    name: this.$t('entrances'),
                    type: 'entrances'
                },
                {
                    name: this.$t('tenants'),
                    type: 'tenants'
                }
            ]
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonConfigParams() {
            return this.getMapConfigProp('components.ODropdownItemsType.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.footer.ODropdownItemsType.params`) || {};
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.ODropdownItemsType.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.footer.ODropdownItemsType.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        dropdownItemsTypes() {
            return this.componentParams.dropdown_items_types || this.dropdownItemsTypesDefault
        }
    },
    methods: {
        changeDropdownType(type) {
            if(!type) return
            if(type === this.value ) {
                this.$emit('input', '')
                return
            }
            this.$emit('input', type)
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
